import { Component } from '@angular/core';
import { NavParams} from 'ionic-angular';
import { AppState } from '../../../../../app/app.global';

@Component({
  selector:'funding-detail',
  templateUrl: 'detail.html'
})
export  class ProjectFundingDetail{
	
  public loading;
  itemDetail:any=[];
  constructor(public navParm :NavParams,public global: AppState) {
    this.itemDetail = navParm.data;
  }

}


// WEBPACK FOOTER //
// ./src/pages/application/research/profunding/detail/detail.ts